import Axios from "axios";

// let configData = {};

let configData = {
  Meeting: {
    MeetingId: "4274cacf-6a70-41b4-b5a1-3cd7dfee5305",
    ExternalMeetingId: "appointment_meeting_440",
    MediaRegion: "us-east-1",
    MediaPlacement: {
      AudioHostUrl:
        "af326bbc5a30b92d145bc8e6087a9b14.k.m2.ue1.app.chime.aws:3478",
      AudioFallbackUrl:
        "wss://wss.k.m2.ue1.app.chime.aws:443/calls/4274cacf-6a70-41b4-b5a1-3cd7dfee5305",
      SignalingUrl:
        "wss://signal.m2.ue1.app.chime.aws/control/4274cacf-6a70-41b4-b5a1-3cd7dfee5305",
      TurnControlUrl:
        "https://5305.cell.ap-south-1.meetings.chime.aws/v2/turn_sessions",
      ScreenDataUrl:
        "wss://bitpw.m2.ue1.app.chime.aws:443/v2/screen/4274cacf-6a70-41b4-b5a1-3cd7dfee5305",
      ScreenViewingUrl:
        "wss://bitpw.m2.ue1.app.chime.aws:443/ws/connect?passcode=null&viewer_uuid=null&X-BitHub-Call-Id=4274cacf-6a70-41b4-b5a1-3cd7dfee5305",
      ScreenSharingUrl:
        "wss://bitpw.m2.ue1.app.chime.aws:443/v2/screen/4274cacf-6a70-41b4-b5a1-3cd7dfee5305",
      EventIngestionUrl:
        "https://data.svc.aps1.ingest.chime.aws/v1/client-events",
    },
    MeetingFeatures: {
      Audio: {
        EchoReduction: "UNAVAILABLE",
      },
      Video: {
        MaxResolution: "HD",
      },
      Content: {
        MaxResolution: "FHD",
      },
      Attendee: {
        MaxCount: 250,
      },
    },
    TenantIds: [],
    MeetingArn:
      "arn:aws:chime:ap-south-1:024422350780:meeting/4274cacf-6a70-41b4-b5a1-3cd7dfee5305",
  },
  Attendees: [
    {
      ExternalUserId: "555",
      AttendeeId: "d958debd-b22c-4335-f3c2-f9cd655ae349",
      JoinToken:
        "ZDk1OGRlYmQtYjIyYy00MzM1LWYzYzItZjljZDY1NWFlMzQ5OjBkMDEyMzE1LTNjMDYtNDNmYi1iZDNlLWY0NTk1MTg4MjNiYw",
      Capabilities: {
        Audio: "SendReceive",
        Video: "SendReceive",
        Content: "SendReceive",
      },
    },
    {
      ExternalUserId: "67",
      AttendeeId: "907f4b74-11cf-d8ce-a461-f35819547aa8",
      JoinToken:
        "OTA3ZjRiNzQtMTFjZi1kOGNlLWE0NjEtZjM1ODE5NTQ3YWE4OjRkN2E5NmZmLWI2YzktNGI5Zi04ZjQ3LTk1Y2UyOGViYzViOA",
      Capabilities: {
        Audio: "SendReceive",
        Video: "SendReceive",
        Content: "SendReceive",
      },
    },
  ],
};

export const postMeetingCredits = async () => {
  let payload = {
    patient_id: 803,
    app_id: 6919,
    doctor_id: 16,
  };
  await Axios.post(
    "http://192.168.26.55:8000/niyama-api/createmeetingcredentials/",
    payload
  ).then((res) => {
    configData = res.data.data;
    console.log(configData, "-------->res  data");
  });
};

export const postLeaveMeeting = async (data) => {
  // let payload = {
  //   meetingID = ,
  //   attendeeID= ,
  //   }
  await Axios.post(
    "http://192.168.26.55:8000/niyama-api/deletemeetingattendee/",
    payload
  ).then((res) => {
    console.log(res, "leave Meeting Res-------->");
  });
};

export const transcriptionStart = async () => {
  let payload = {
    meeting_id: configData?.Meeting?.MeetingId,
    connection: "start",
  };

  await Axios.post(
    "http://192.168.26.55:8000/niyama-api/settranscribe/",
    payload
  ).then((res) => {
    console.log(res, "transcription start--->");
  });
};

export const postCreatePipeLine = async (data) => {
  let payload = {};
  payload.meeting_id = data.MeetingId;
  payload.meeting_arn = data.MeetingArn;

  console.log(data, "pipeline data--->");

  console.log(payload, " pipeline payload--->");
  await Axios.post(
    "http://192.168.26.55:8000/niyama-api/createmediapipeline/",
    payload
  ).then((res) => {
    console.log(res, "Pipeline res ----->");
  });
};

export let BotoMeetingDataConfig = () => {
  return {
    ResponseMetadata: configData?.ResponseMetadata,
    Meeting: configData?.Meeting,
  };
};

// export let BotoMeetingData = {
//   ResponseMetadata : configData?.ResponseMetadata,
//     Meeting : configData?.Meeting,
// }

export let BotoAttendeeDataOneConfig = () => {
  return {
    ResponseMetadata: configData?.ResponseMetadata,
    Attendee1: configData?.Attendees[0],
  };
};

export let BotoAttendeeDataTwoConfig = () => {
  return {
    ResponseMetadata: configData?.ResponseMetadata,
    Attendee2: configData?.Attendees[1],
  };
};

export let BotoIVSChannelData = {
  ResponseMetadata: {
    RequestId: "96dc8908-c42b-43b5-a7e4-816716dad41e",
    HTTPStatusCode: 200,
    HTTPHeaders: {
      "content-type": "application/json",
      "content-length": "653",
      connection: "keep-alive",
      date: "Fri, 21 Jul 2023 10:00:30 GMT",
      "x-amzn-requestid": "96dc8908-c42b-43b5-a7e4-816716dad41e",
      "access-control-allow-origin": "*",
      "strict-transport-security": "max-age:47304000; includeSubDomains",
      "x-amzn-remapped-content-length": "825",
      "x-frame-options": "DENY",
      "content-security-policy":
        "default-src 'self'; upgrade-insecure-requests;",
      "x-amz-apigw-id": "IaKR2EUvIAMFpUA=",
      "cache-control": "no-store, no-cache",
      "x-content-type-options": "nosniff",
      "access-control-expose-headers": "*",
      "x-amzn-trace-id": "Root=1-64ba573e-569e905936e0e4cd1fedb02b",
      "x-amzn-remapped-date": "Fri, 21 Jul 2023 10:00:30 GMT",
      "x-cache": "Miss from cloudfront",
      via: "1.1 b863175923d6206c18a8c6260f57ceaa.cloudfront.net (CloudFront)",
      "x-amz-cf-pop": "MAA50-P1",
      "x-amz-cf-id": "8304hIH5wWltxCzN4pBLSzlK9y0KTxYMCmWnBgPmhgemUtiP5E3gtQ==",
    },
    RetryAttempts: 0,
  },
  channel: {
    arn: "arn:aws:ivs:us-east-1:742375465433:channel/zOdZdzIUOEnw",
    authorized: false,
    ingestEndpoint: "e0d2ee9fea05.global-contribute.live-video.net",
    insecureIngest: false,
    latencyMode: "LOW",
    name: "yokesh",
    playbackUrl:
      "https://e0d2ee9fea05.us-east-1.playback.live-video.net/api/video/v1/us-east-1.742375465433.channel.zOdZdzIUOEnw.m3u8",
    preset: "",
    recordingConfigurationArn: "",
    tags: {},
    type: "STANDARD",
  },
  streamKey: {
    arn: "arn:aws:ivs:us-east-1:742375465433:stream-key/sruSbvpW7PN5",
    channelArn: "arn:aws:ivs:us-east-1:742375465433:channel/zOdZdzIUOEnw",
    tags: {},
    value: "sk_us-east-1_sruSbvpW7PN5_yz6Wus8T3h8x1fHlXHB5JnbLsj20Na",
  },
};

// export const BotoMeetingData = {

//   ResponseMetadata: {
//     RequestId: "a07bf5af-1ac7-4393-b633-92c6eb5d1775",
//     HTTPStatusCode: 200,
//     HTTPHeaders: {
//         date: "Fri, 31 May 2024 04:55:33 GMT",
//         "content-type": "application/json",
//         "content-length": "1847",
//         connection: "keep-alive",
//         "x-amzn-requestid": "a07bf5af-1ac7-4393-b633-92c6eb5d1775"
//     },
//     RetryAttempts: 0
// },
// Meeting: {
//     MeetingId: "5bd62157-6965-420b-a7f6-baea61b62713",
//     MeetingHostId: "6919",
//     ExternalMeetingId: "6vOb0VjWroSNy1RJvXjEP6CA2O7pgyhY",
//     MediaRegion: "us-east-1",
//     MediaPlacement: {
//         AudioHostUrl: "1004f01aaa27e0e47b1f0aadb003f154.k.m3.ue1.app.chime.aws:3478",
//         AudioFallbackUrl: "wss://wss.k.m3.ue1.app.chime.aws:443/calls/5bd62157-6965-420b-a7f6-baea61b62713",
//         SignalingUrl: "wss://signal.m3.ue1.app.chime.aws/control/5bd62157-6965-420b-a7f6-baea61b62713",
//         TurnControlUrl: "https://2713.cell.us-east-1.meetings.chime.aws/v2/turn_sessions",
//         ScreenDataUrl: "wss://bitpw.m3.ue1.app.chime.aws:443/v2/screen/5bd62157-6965-420b-a7f6-baea61b62713",
//         ScreenViewingUrl: "wss://bitpw.m3.ue1.app.chime.aws:443/ws/connect?passcode=null&viewer_uuid=null&X-BitHub-Call-Id=5bd62157-6965-420b-a7f6-baea61b62713",
//         ScreenSharingUrl: "wss://bitpw.m3.ue1.app.chime.aws:443/v2/screen/5bd62157-6965-420b-a7f6-baea61b62713",
//         EventIngestionUrl: "https://data.svc.ue1.ingest.chime.aws/v1/client-events"
//     },
//     MeetingFeatures: {
//         Audio: {
//             EchoReduction: "UNAVAILABLE"
//         },
//         Video: {
//             MaxResolution: "HD"
//         },
//         Content: {
//             MaxResolution: "FHD"
//         },
//         Attendee: {
//             MaxCount: 250
//         }
//     },
//     TenantIds: [],
//     MeetingArn: "arn:aws:chime:us-east-1:024422350780:meeting/5bd62157-6965-420b-a7f6-baea61b62713"
// },

// };

// export const BotoAttendeeDataOne = {
//   // ResponseMetadata: {
//   //   RequestId: "295c3b59-96f3-4a04-8ccc-14e2ed192dbb",
//   //   HTTPStatusCode: 201,
//   //   HTTPHeaders: {
//   //     "x-amzn-requestid": "295c3b59-96f3-4a04-8ccc-14e2ed192dbb",
//   //     "content-type": "application/json",
//   //     "content-length": "232",
//   //     date: "Mon, 24 Jul 2023 08:33:56 GMT",
//   //   },
//   //   RetryAttempts: 0,
//   // },

//   ResponseMetadata: {
//     RequestId: "a07bf5af-1ac7-4393-b633-92c6eb5d1775",
//     HTTPStatusCode: 200,
//     HTTPHeaders: {
//         date: "Fri, 31 May 2024 04:55:33 GMT",
//         "content-type": "application/json",
//         "content-length": "1847",
//         connection: "keep-alive",
//         "x-amzn-requestid": "a07bf5af-1ac7-4393-b633-92c6eb5d1775"
//     },
//     RetryAttempts: 0
// },

//   // Attendee: {
//   //   ExternalUserId: "attendee1@example.com",
//   //   AttendeeId: "b26baff1-941a-176a-be43-ac0d648fb0cc",
//   //   JoinToken:
//   //     "YjI2YmFmZjEtOTQxYS0xNzZhLWJlNDMtYWMwZDY0OGZiMGNjOmQ1MmNjYTI2LWYyMDQtNGEzZS05MjI0LWRmYjMzNjZjZTcyNQ",
//   //   Capabilities: {
//   //     Audio: "SendReceive",
//   //     Video: "SendReceive",
//   //     Content: "SendReceive",
//   //   },
//   // },

//   Attendee1: {
//     ExternalUserId: "803",
//     AttendeeId: "097d48c5-502e-127c-67e2-a18fb47d9c64",
//     JoinToken: "MDk3ZDQ4YzUtNTAyZS0xMjdjLTY3ZTItYTE4ZmI0N2Q5YzY0OjA2ZmIxM2NmLTE0YzYtNGFjZC1iYmIwLTRjMmNmNzM5ODI3NA",
//     Capabilities: {
//         Audio: "SendReceive",
//         Video: "SendReceive",
//         Content: "SendReceive"
//     }
// },
// };

// export const BotoAttendeeDataTwo = {
//   // ResponseMetadata: {
//   //   RequestId: "215a3322-871b-4482-a77c-cab6a05fe7c8",
//   //   HTTPStatusCode: 201,
//   //   HTTPHeaders: {
//   //     "x-amzn-requestid": "215a3322-871b-4482-a77c-cab6a05fe7c8",
//   //     "content-type": "application/json",
//   //     "content-length": "232",
//   //     date: "Mon, 24 Jul 2023 07:38:22 GMT",
//   //   },
//   //   RetryAttempts: 0,
//   // },

//   ResponseMetadata: {
//     RequestId: "a07bf5af-1ac7-4393-b633-92c6eb5d1775",
//     HTTPStatusCode: 200,
//     HTTPHeaders: {
//         date: "Fri, 31 May 2024 04:55:33 GMT",
//         "content-type": "application/json",
//         "content-length": "1847",
//         connection: "keep-alive",
//         "x-amzn-requestid": "a07bf5af-1ac7-4393-b633-92c6eb5d1775"
//     },
//     RetryAttempts: 0
// },

//   // Attendee: {
//   //   ExternalUserId: "attendee2@example.com",
//   //   AttendeeId: "e871d708-3e90-737f-2951-a5d27ba7fc99",
//   //   JoinToken:
//   //     "ZTg3MWQ3MDgtM2U5MC03MzdmLTI5NTEtYTVkMjdiYTdmYzk5OjdkYmEwODVjLThhMzQtNDhjMC1hYzcyLTM0ZDhlMWE0ZjQ3Yg",
//   //   Capabilities: {
//   //     Audio: "SendReceive",
//   //     Video: "SendReceive",
//   //     Content: "SendReceive",
//   //   },
//   // },

//   Attendee2: {
//     ExternalUserId: "16",
//     AttendeeId: "18d656a9-49d5-61d3-270a-a14f6e0d3c9b",
//     JoinToken: "MThkNjU2YTktNDlkNS02MWQzLTI3MGEtYTE0ZjZlMGQzYzliOmNlNWU2YjE1LTY4MzEtNGQ3Yy05MjY1LWNkMWMyYzI4M2U3Nw",
//     Capabilities: {
//         Audio: "SendReceive",
//         Video: "SendReceive",
//         Content: "SendReceive"
//     }
// }
// };

// export const BotoIVSChannelData = {
//   ResponseMetadata: {
//     RequestId: "96dc8908-c42b-43b5-a7e4-816716dad41e",
//     HTTPStatusCode: 200,
//     HTTPHeaders: {
//       "content-type": "application/json",
//       "content-length": "653",
//       connection: "keep-alive",
//       date: "Fri, 21 Jul 2023 10:00:30 GMT",
//       "x-amzn-requestid": "96dc8908-c42b-43b5-a7e4-816716dad41e",
//       "access-control-allow-origin": "*",
//       "strict-transport-security": "max-age:47304000; includeSubDomains",
//       "x-amzn-remapped-content-length": "825",
//       "x-frame-options": "DENY",
//       "content-security-policy":
//         "default-src 'self'; upgrade-insecure-requests;",
//       "x-amz-apigw-id": "IaKR2EUvIAMFpUA=",
//       "cache-control": "no-store, no-cache",
//       "x-content-type-options": "nosniff",
//       "access-control-expose-headers": "*",
//       "x-amzn-trace-id": "Root=1-64ba573e-569e905936e0e4cd1fedb02b",
//       "x-amzn-remapped-date": "Fri, 21 Jul 2023 10:00:30 GMT",
//       "x-cache": "Miss from cloudfront",
//       via: "1.1 b863175923d6206c18a8c6260f57ceaa.cloudfront.net (CloudFront)",
//       "x-amz-cf-pop": "MAA50-P1",
//       "x-amz-cf-id": "8304hIH5wWltxCzN4pBLSzlK9y0KTxYMCmWnBgPmhgemUtiP5E3gtQ==",
//     },
//     RetryAttempts: 0,
//   },
//   channel: {
//     arn: "arn:aws:ivs:us-east-1:742375465433:channel/zOdZdzIUOEnw",
//     authorized: false,
//     ingestEndpoint: "e0d2ee9fea05.global-contribute.live-video.net",
//     insecureIngest: false,
//     latencyMode: "LOW",
//     name: "yokesh",
//     playbackUrl:
//       "https://e0d2ee9fea05.us-east-1.playback.live-video.net/api/video/v1/us-east-1.742375465433.channel.zOdZdzIUOEnw.m3u8",
//     preset: "",
//     recordingConfigurationArn: "",
//     tags: {},
//     type: "STANDARD",
//   },
//   streamKey: {
//     arn: "arn:aws:ivs:us-east-1:742375465433:stream-key/sruSbvpW7PN5",
//     channelArn: "arn:aws:ivs:us-east-1:742375465433:channel/zOdZdzIUOEnw",
//     tags: {},
//     value: "sk_us-east-1_sruSbvpW7PN5_yz6Wus8T3h8x1fHlXHB5JnbLsj20Na",
//   },
// };
